// Account & Settings articles for the Help Center.

const account = {
  slug: 'account',
  label: 'Account & Settings',
  icon: 'PiGear',
  description: 'Update your info, manage security, and control what you get notified about.',
  articles: [
    {
      slug: 'verifying-your-email',
      title: 'Verifying your email',
      summary: 'Confirm your email within a few days of signing up so you keep full access.',
      body: [
        {
          type: 'p',
          text: 'When you sign up with an email and password, we send a verification link to confirm it is really yours. Accounts created with Google sign-in are verified automatically, since Google has already confirmed that email for you.',
        },
        {
          type: 'p',
          text: 'You get a short grace period after signing up before this is enforced, so you can look around first. After that, verifying becomes required before you can open a service, apply to a job, or post one of your own.',
        },
        {
          type: 'note',
          text: 'Using a .edu address? Some school email systems file the verification message under Junk or Spam by default, so check there if it does not show up in your main inbox within a few minutes.',
        },
        {
          type: 'p',
          text: 'You can resend the verification email any time from Settings, under Personal Info, if the link expires or you cannot find the original message.',
        },
      ],
    },
    {
      slug: 'getting-your-verified-badge',
      title: 'Getting your verified badge',
      summary: 'Confirm your university affiliation to open a service listing.',
      body: [
        {
          type: 'p',
          text: 'Freelancers need a verified university affiliation before they can open a service. You can confirm it two ways: instantly, by sending a confirmation link to a .edu email address, or by uploading a diploma, transcript, student ID, or alumni card for our team to review if you no longer have a school email.',
        },
        {
          type: 'steps',
          items: [
            'Go to Settings and open University Verification.',
            'Choose school email for an instant link, or document upload if you are an alum without one.',
            'For the email route, click the link we send within 24 hours.',
            'For the document route, pick a document type, upload a photo or PDF, and submit it for review.',
          ],
        },
        {
          type: 'note',
          text: 'Didn’t get the confirmation email? You can switch to the document route from the same screen instead of waiting on it.',
        },
        {
          type: 'note',
          text: 'Uploaded documents are reviewed by a real person on our team, never shown publicly, and used only to confirm your affiliation.',
        },
      ],
    },
    {
      slug: 'updating-your-personal-info',
      title: 'Updating your personal info',
      summary: 'Change your name, email, university, or profile photo any time.',
      body: [
        {
          type: 'p',
          text: 'Go to Settings and open Personal Info to update your name or email. Your profile photo, bio, and skills live under Freelancer Profile, and your university is set from either of those sections depending on what you are updating.',
        },
        {
          type: 'p',
          text: 'Changes save as soon as you confirm them and take effect right away across the site.',
        },
      ],
    },
    {
      slug: 'changing-your-password',
      title: 'Changing your password',
      summary: 'Update your password from Settings under Security.',
      body: [
        {
          type: 'p',
          text: 'Go to Settings, then Security, and enter your current password along with the new one you want to use. You will need to confirm the new password by typing it twice, so there is no mistake.',
        },
        {
          type: 'note',
          text: 'If you cannot remember your current password, use the forgot password link on the login page instead.',
        },
      ],
    },
    {
      slug: 'managing-notifications',
      title: 'Managing your notifications',
      summary: 'Choose what shows up in your notification bell and your inbox.',
      body: [
        {
          type: 'p',
          text: 'Go to Settings, then Notifications, to control what you get notified about. New messages, order updates, and payment events all have their own toggle, so you can turn off the ones you do not need without losing the important ones.',
        },
      ],
    },
    {
      slug: 'closing-your-account',
      title: 'Closing your account',
      summary: 'Contact support to close your account.',
      body: [
        {
          type: 'p',
          text: 'If you want to close your account, message support and let them know. They will confirm there is nothing left in progress, like an active order or a contract still awaiting payment, before closing it out, so nothing gets left in a broken state.',
        },
      ],
    },
  ],
};

export default account;
